import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgUsersAdded = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 14,
	height: 18,
	viewBox: "0 0 14 18",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#clip0_3018_125319)",
		children: [
			/* @__PURE__ */ _jsx("path", {
				d: "M6.43231 0.0383357C11.8856 -0.618294 12.553 7.3706 7.50006 7.90026C2.13062 8.46342 1.46445 0.636768 6.43231 0.0383357Z",
				fill: "currentColor"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M10.2986 15.5691C11.0326 14.8384 11.2712 14.2524 10.5743 13.38C8.78847 11.1438 7.86837 12.8497 6.41025 14.2394C5.89882 13.6234 5.1742 13.1637 4.37988 13.6275C3.90034 13.9073 2.94775 14.9584 2.99028 15.5656C1.09751 15.5621 -0.12556 14.9413 0.0102706 12.8744C0.158503 10.6283 2.04005 8.76712 4.28598 8.61075C5.78012 8.5067 8.4672 8.4779 9.93535 8.62369C11.0515 8.73479 12.3142 9.46902 13.0016 10.3402C14.067 11.6899 14.719 14.6403 12.6183 15.3387C12.3785 15.4187 11.7384 15.5703 11.5157 15.5703H10.298L10.2986 15.5691Z",
				fill: "currentColor"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M8.86412 13.1577C9.15409 13.113 10.1894 14.1182 10.1114 14.3981L6.60697 17.9504C6.5237 17.9981 6.43157 18.0069 6.33767 17.9934C6.04652 17.9504 4.2819 15.9559 3.91575 15.6226L3.875 15.4627C3.8939 15.2628 4.85771 14.3093 5.07622 14.3093C5.40398 14.3093 6.10321 15.271 6.41149 15.4885C6.86564 15.1717 8.47552 13.2177 8.86412 13.1577Z",
				fill: "currentColor"
			})
		]
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_3018_125319",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 14,
			height: 18,
			fill: "currentColor"
		})
	}) })]
});
export default SvgUsersAdded;
